module.exports = __webpack_public_path__ + "static/media/G1-13-Sapphira-Andreas-cod33.b674eb39.png";